<div class="menu-container">
  <app-button [button]="doctorsButton"> </app-button>
  <app-button [button]="bodyScanButton"> </app-button>
</div>
